// src/components/DataImport/ColumnMapper.tsx
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

import { ParsedSheetRow } from "./useSpreadsheetParser";

import BasePaper from "components/Base/BasePaper";
import { ColumnFieldSelector } from "components/Base/SubMenuSelector";

export interface ModelFieldOption {
  field: string;
  label: string;
}

interface ColumnMapperProps {
  columns: string[];
  data: ParsedSheetRow[];
  mapping: Record<string, string>;
  onMappingChange: (fileColumn: string, modelField: string) => void;
  modelFields: ModelFieldOption[];
}

const ColumnMapper: React.FC<ColumnMapperProps> = ({
  columns,
  data,
  mapping,
  onMappingChange,
  modelFields,
}) => (
  <>
    <TableContainer component={BasePaper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>File Column</strong></TableCell>
            <TableCell><strong>Imported Data Field</strong></TableCell>
            <TableCell><strong>Sample Data</strong></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {columns.map((header) => {
            const sample = data.slice(0, 3)
              .map((row) => String(row[header] ?? "").slice(0, 60))
              .filter(Boolean)
              .join(", ");

            return (
              <TableRow key={header}>
                <TableCell>{header}</TableCell>

                <TableCell>
                  <ColumnFieldSelector
                    header={header}
                    mapping={mapping}
                    onMappingChange={onMappingChange}
                    modelFields={modelFields}
                  />
                </TableCell>

                <TableCell sx={{ fontSize: 14, color: "text.secondary" }}>
                  {sample || "—"}
                </TableCell>
              </TableRow>

            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </>
);

export default ColumnMapper;
